import { Box } from "@chakra-ui/react"
import { FaCircleInfo } from "react-icons/fa6"
import { Tooltip } from "../chakra/Tooltip"
import { ScopeChip, SCOPE_CHIP_COLOURS } from "../components/ScopeLinkChip"

const MANAGED_BY = {
  asset: {
    colours: SCOPE_CHIP_COLOURS.asset,
    tooltip: "This connection belongs to the asset. Switch it on or off and change its mapping on the asset's Data Connections tab.",
  },
  system: {
    colours: SCOPE_CHIP_COLOURS.system,
    tooltip: "This connection belongs to the system. Switch it on or off and change its mapping on the system's Data Connections tab.",
  },
}

/**
 * Says which entity a connection is managed on, in that entity's scope
 * colours, with the reason in a tooltip.
 */
export function ManagedByChip({
  scope,
  detail,
  tooltip: tooltipOverride,
}: {
  scope: "asset" | "system"
  detail?: string
  /** Why, for something other than a connection (e.g. an alert) */
  tooltip?: string
}) {
  const { colours, tooltip: connectionTooltip } = MANAGED_BY[scope]
  const tooltip = tooltipOverride ?? connectionTooltip
  return (
    <Tooltip
      content={tooltip}
      contentProps={{ css: { "--tooltip-bg": "white", color: "primary", textTransform: "none" } }}
    >
      <Box display="inline-flex" cursor="help">
        <ScopeChip colours={colours}>
          <FaCircleInfo style={{ fontSize: "11px" }} />
          Managed on the {scope}
          {detail && ` · ${detail}`}
        </ScopeChip>
      </Box>
    </Tooltip>
  )
}

export default ManagedByChip
